module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAXCAYAAAARIY8tAAAACXBIWXMAAAsSAAALEgHS3X78AAAA/ElEQVRIie1V7Q2CMBQ8jAOwgYyAG7iBbgAj4Aa6ASMwAhvYEXADRmCDM8W+pNZG+WgTf3hJQ/pa7tp7ea8JSRhkACoAOdZhAFADUCOLFiCZkxwYFuV4eCPQBianOXAqAi5KE58zfC4cfALVAnLb6heBjSed3YoUv/3rEwiKv8BvCugyTxfyNW5AelEPYGfF7wDameS6hx2d2F4K5BKhVXR2L9KjCUyuqxp2u5Zrav9LAAWA88TKvhlbKzNXsrB1NgrZwZorTMPg2/utDsoJ1KdPi+4NBL35Fs7cB7Fl8K5GSLCgJ5kl46PwTFIMXHUO/FcLBWNRHcEiRTJ9AGAl8C60EI1SAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/logo/franquicia-ic.png
// module id = 249
// module chunks = 0